import axios from 'axios'
import { cancelOutsideMentorTour } from '@/modules/mentor-tour/demoMode'

let isAxiosSetup = false

type SetupAxiosOptions = {
  csrfToken?: string | null
}

export const setupAxios = ({ csrfToken }: SetupAxiosOptions = {}) => {
  if (isAxiosSetup) return
  isAxiosSetup = true

  axios.defaults.headers.common['Accept'] = 'application/json'

  // The mentor tour draws member pages for a visitor: no request leaves it.
  axios.interceptors.request.use(cancelOutsideMentorTour)

  if (csrfToken) {
    axios.interceptors.request.use((config) => {
      try {
        const baseURL = config.baseURL || window.location.origin
        const requestUrl = new URL(config.url || '', baseURL)

        if (requestUrl.origin === window.location.origin) {
          config.headers = config.headers || {}
          config.headers['X-CSRF-TOKEN'] = csrfToken
        } else if (config.headers) {
          delete config.headers['X-CSRF-TOKEN']
        }
      } catch {
        // noop
      }

      return config
    })
  }
}
